import { render } from "./TerminationsIndex.vue?vue&type=template&id=6b016f1a"
import script from "./TerminationsIndex.vue?vue&type=script&lang=js"
export * from "./TerminationsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__